module.exports = "/_next/static/images/FrameMobile@2x-04c1c415f2786d5ceb4e5532a2ff08bd.webp";